import Vue from "vue";
import Toast from "./index.vue";

const ToastConstructor = Vue.extend(Toast);

function install(Vue, globalOptions = {}) {
  Vue.prototype.$toast = function (message, options = {}) {
    let instance = new ToastConstructor().$mount(document.createElement("div"));
    instance.message = message;
    Object.assign(instance, globalOptions, options);
    document.body.appendChild(instance.$el);

    Vue.nextTick(() => {
      instance.showToast(instance.message, instance.type, instance.duration);
    });
  };
}

export default install;
